import React, { useState, KeyboardEvent } from 'react';

interface TagInputProps {
  value: string[];
  onChange: (tags: string[]) => void;
  placeholder?: string;
  className?: string;
}

const TagInput: React.FC<TagInputProps> = ({ value, onChange, placeholder = "Write tags and press enter", className = "" }) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && inputValue.trim()) {
      e.preventDefault();
      if (!value.includes(inputValue.trim())) {
        onChange([...value, inputValue.trim()]);
      }
      setInputValue('');
    } else if (e.key === 'Backspace' && !inputValue && value.length > 0) {
      onChange(value.slice(0, -1));
    }
  };

  const removeTag = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <div className={`tag-input-wrapper ${className}`}>
      <div className="d-flex flex-wrap align-items-center gap-2 p-2 border rounded" style={{ minHeight: '48px', borderColor: '#e4e6ef' }}>
        {value.map((tag, index) => (
          <span
            key={index}
            className="badge badge-light-primary d-flex align-items-center"
            style={{ padding: '4px 8px', fontSize: '0.875rem' }}
          >
            {tag}
            <button
              type="button"
              className="btn btn-sm btn-icon ms-2"
              style={{ padding: '0', border: 'none', background: 'none', cursor: 'pointer' }}
              onClick={() => removeTag(index)}
            >
              <i className="fas fa-times" style={{ fontSize: '0.75rem' }}></i>
            </button>
          </span>
        ))}
        <input
          type="text"
          className="border-0 flex-grow-1"
          style={{ outline: 'none', minWidth: '150px' }}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={value.length === 0 ? placeholder : ''}
        />
      </div>
    </div>
  );
};

export default TagInput;

